<template>
    <div>
        <div class="header pt-5">
            <div>
                {{ headerText }}
            </div>
            <div>
                <v-btn
                    @click="cancel()"
                    outlined
                    class="mr-2"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.blacklistForm.cancel') }}
                </v-btn>

                <v-btn
                    @click="submit()"
                    width="150"
                    color="primary">
                    {{ $vuetify.lang.t('$vuetify.blacklistForm.save') }}
                </v-btn>
            </div>
        </div>
        <v-form
            lazy-validation
            ref="form"
            v-model="valid">
            <v-container>
                <v-row>
                    <v-col cols="8">
                        <v-card class="blacklist-profile px-10 py-5 content-container">
                            <v-row>
                                <v-col
                                    cols="12"
                                    class="blacklist-profile-text-box">
                                    <span class="blacklist-profile-text locale-font">
                                        {{ $vuetify.lang.t('$vuetify.blacklistForm.profile') }}
                                    </span>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="3">
                                    <div class="d-flex-center">
                                        <profile
                                            :isEditing="true"
                                            @change-profile-img="changeProfileImg"
                                            :img="form.image"/>
                                    </div>
                                    <div class="image-size-info">
                                        <center>
                                            {{ $vuetify.lang.t('$vuetify.blacklistForm.msgImageSize') }}
                                        </center>
                                    </div>
                                </v-col>
                                <v-col cols="9">
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="form.name"
                                                :label="$vuetify.lang.t('$vuetify.blacklistForm.name')"
                                                autocomplete="off"
                                                placeholder=" "
                                                :rules="inputRules"
                                                :error-messages="errors.name">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field
                                                v-model="form.surname"
                                                :label="$vuetify.lang.t('$vuetify.blacklistForm.surname')"
                                                autocomplete="off"
                                                placeholder=" "
                                                :rules="inputRules"
                                                :error-messages="errors.surname">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="6">
                                            <label>{{ $vuetify.lang.t('$vuetify.blacklistForm.gender') }}</label>
                                            <v-radio-group
                                                v-model="form.gender"
                                                row
                                                :rules="inputRules"
                                                :error-messages="errors.gender">
                                                <v-radio :label="$vuetify.lang.t('$vuetify.blacklistForm.male')" value="M"></v-radio>
                                                <v-radio :label="$vuetify.lang.t('$vuetify.blacklistForm.female')" value="F"></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-textarea
                                            v-model="form.reason"
                                            autocomplete="off"
                                            :label="$vuetify.lang.t('$vuetify.blacklistForm.reason')"
                                            :placeholder="$vuetify.lang.t('$vuetify.blacklistForm.writeReason')">
                                        </v-textarea>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                    <v-col cols="4">
                        <v-card class="blacklist-access-info px-5 py-5 content-container">
                            <v-row>
                                <v-col
                                    cols="12"
                                    class="blacklist-status">
                                    <span class="blacklist-profile-text locale-font">
                                        {{ $vuetify.lang.t('$vuetify.blacklistForm.status') }}
                                    </span>
                                    <div class="blacklist-icon-container">
                                        <v-icon class="blacklist-icon mr-3">
                                            warning
                                        </v-icon>

                                        <span class="blacklist-text">
                                            Blacklist
                                        </span>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <toggle-status
                                    v-model="isActiveBlacklist"/>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import profileDefault from '@/assets/user_default.png'
import Profile from '@/components/Profile'
import ToggleStatus from '@/components/ToggleStatus.vue'

export default {
    name: 'BlacklistForm',

    components: {
        Profile,
        ToggleStatus
    },

    computed: {
        headerText () {
            let header = this.$vuetify.lang.t('$vuetify.blacklistForm.createBlacklistText')
            if (this.mode === 'edit') {
                header = this.$vuetify.lang.t('$vuetify.blacklistForm.updateBlacklistText')
            }
            return header
        },
        errorMsg () {
            return this.$vuetify.lang.t('$vuetify.blacklistForm.msgError')
        },
        msgErrorImageSize () {
            return {
                title: this.errorMsg,
                text: this.$vuetify.lang.t('$vuetify.blacklistForm.msgErrorImageSize'),
                type: 'error'
            }
        },

        msgErrorNoImage () {
            return {
                title: this.errorMsg,
                text: this.$vuetify.lang.t('$vuetify.blacklistForm.errorNoImage'),
                type: 'error'
            }
        }
    },

    data () {
        return {
            status: {
                active: 'ACT',
                deactive: 'DEA'
            },
            isActiveBlacklist: true,
            valid: true,
            blacklistId: null,
            mode: 'create',
            form: {
                image: profileDefault,
                name: '',
                surname: '',
                gender: '',
                reason: ''
            },
            errors: {},
            inputRules: [
                v => this.$validator.hasValue(v, this.$vuetify.lang.t('$vuetify.blacklistForm.msgRequiredField')),
                v => this.$validator.lengthNotExceed(v, 255, this.$vuetify.lang.t('$vuetify.blacklistForm.msgExceededField'))
            ],
            tmpBlacklistToUpdateImage: null
        }
    },

    methods: {
        displayNoti (listMsg) {
            // for object to display response noti
            for (const property in listMsg) {
                let type = ''
                let title = ''
                if (listMsg[property].status === 'ok') {
                    title = this.congratulationTitle
                    type = 'success'
                } else if (listMsg[property].status === 'warning') {
                    title = this.warningTitle
                    type = 'warn'
                } else if (listMsg[property].status === 'error') {
                    title = this.errorTitle
                    type = 'error'
                }
                this.$notify({
                    title: title,
                    text: listMsg[property].msg,
                    type: type
                })
            }
        },

        async submit () {
            if (!this.$refs.form.validate()) {
                return
            }

            if (this.form.image === profileDefault) {
                this.$notify(this.msgErrorNoImage)
                return
            }

            if (this.mode === 'create') {
                await this.createBlacklist()
            } else if (this.mode === 'edit') {
                await this.updateBlacklist()
            }
        },

        cancel () {
            this.$router.back()
        },

        getFormStatus () {
            let status = null
            if (this.isActiveBlacklist) {
                status = this.status.active
            } else {
                status = this.status.deactive
            }

            return status
        },

        async createBlacklist () {
            this.$store.dispatch('setLoading', true)

            const form = {
                image: this.form.image,
                name: this.form.name,
                surname: this.form.surname,
                gender: this.form.gender,
                reason: this.form.reason,
                status: this.getFormStatus()
            }

            const res = await this.axios.post('blacklist/create', form)
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.displayNoti(res.data.data)
                this.$router.push({ name: 'Blacklist' }, () => {})
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
                for (const property in this.errors) {
                    this.$notify({
                        title: this.errorMsg,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async updateBlacklist () {
            this.$store.dispatch('setLoading', true)

            let isUpdateImage = false
            if (this.tmpBlacklistToUpdateImage !== this.form.image) {
                isUpdateImage = true
            }

            const form = {
                isUpdateImage: isUpdateImage,
                image: this.form.image,
                name: this.form.name,
                surname: this.form.surname,
                gender: this.form.gender,
                reason: this.form.reason,
                status: this.getFormStatus()
            }

            const res = await this.axios.put(`blacklist/edit/${this.blacklistId}`, form)
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.displayNoti(res.data.data)
                this.$router.push({ name: 'Blacklist' }, () => {})
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
                for (const property in this.errors) {
                    this.$notify({
                        title: this.errorMsg,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async getBlacklist () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.get(`blacklist/${this.blacklistId}`)
            if (res && res.data && res.data.status === 'ok') {
                const blacklist = res.data.data

                if (blacklist.image) {
                    this.tmpBlacklistToUpdateImage = blacklist.image
                    this.form.image = blacklist.image
                }

                if (blacklist.status === this.status.active) {
                    this.isActiveBlacklist = true
                } else if (blacklist.status === this.status.deactive) {
                    this.isActiveBlacklist = false
                }

                this.form.name = blacklist.name
                this.form.surname = blacklist.surname
                this.form.gender = blacklist.gender
                this.form.reason = blacklist.reason

                this.$store.dispatch('setLoading', false)
            }
        },

        changeProfileImg (event) {
            const fileList = event.target.files
            const maxFileSize = 200000
            const minFileSize = 25000

            const reader = new FileReader()

            if (fileList[0] && (fileList[0].size < minFileSize || fileList[0].size > maxFileSize)) {
                this.$notify(this.msgErrorImageSize)
            } else {
                if (fileList[0]) {
                    reader.onload = async () => {
                        // reader.result is base64
                        this.form.image = reader.result
                    }
                    reader.readAsDataURL(fileList[0])
                }
            }
        }
    },

    async mounted () {
        this.blacklistId = this.$route.params.id
        if (this.blacklistId) {
            this.mode = 'edit'
            await this.getBlacklist()
        } else {
            this.mode = 'create'
        }
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.$util.recheckValidate(this.$refs.form.inputs)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .action-header {
        display: flex;

        .btn-action {
            margin: 1rem;
        }
    }
}
.blacklist-profile, .blacklist-access-info {
    border-radius: 15px;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    background-color: #ffffff;
}
.blacklist-profile-text, .blacklist-access-text {
    font-size: 24px;
}
.blacklist-profile-text-box {
    display: flex;
}
.blacklist-status, .blacklist-icon-container {
    display: flex;
    justify-content: space-between;
}
.image-size-info {
    font-size: 9px;
    color: gray;
}
.blacklist-text {
    font-size: 32px;
    color: #ff544a;
}
.blacklist-icon {
    font-size: 32px;
    color: #ff544a;
}
</style>
